<mat-card appearance="outlined">
  <mat-card-title [innerText]=" cardTitle | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroupTimeRecorder">
    <span class="row">
      <mat-form-field>
        <mat-label>
          {{ "MAIN_APP_SERVICE_APP.auftrag" | translate }}
        </mat-label>
        <input type="text" placeholder="Objekt wählen" aria-label="Suche" matInput formControlName="fldObjekt" [matAutocomplete]="auto" required />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getObjektDesc" (optionSelected)="selectedSearchItem($event)">
          <mat-option *ngFor="let objekt of filteredDescriptions | async" [value]="objekt">
            {{ objekt.beschreibung }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.kostenstelle" | translate }}</mat-label>
        <mat-select formControlName="fldKostenstellen" (selectionChange)="kostenstelleChange($event.value)" required>
          <mat-option *ngFor="let coastcenter of dbKostenstellen" [value]="coastcenter.costCenterID">
            {{ coastcenter.costCenterID + " " + coastcenter.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </span>

    <span class="row">
	    <ng-container *ngIf="this.fldWorkplaceRequired">
		    <mat-form-field *ngIf="this.fldWorkplaceRequired" class="workplaceContainer">
          <mat-label>{{ "MAIN_APP_SERVICE_APP.arbeitsort" | translate }}</mat-label>
          <input matInput formControlName="fldArbeitsort" required />
        </mat-form-field>
        <fa-icon style="color: black; margin-left: 12px" [icon]="faSearchLocation" (click)="setLocation()"></fa-icon>
      </ng-container>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.startzeit" | translate }}</mat-label>
        <input type="time" matInput formControlName="fldStartZeit" [value]="startZeit" required />
      </mat-form-field>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroupTimeRecorder.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
